import { SidebarPlugins } from "@/platform/plugins";

export function SidebarPluginsEntry() {
  return <SidebarPlugins />;
}
